export default class Modal {
    constructor(element) {
        if( !element ){
            throw new Error('Element required to initialize object');
        }
        this.closedModalHash = '#-'; // it used to be #! but it throws an 'unrecognized expression' error

        this.element = element;
        this.$element = $(element);

        this.noHistory = !!this.$element.data('modalNoHistory') === true;

        let self = this;

        this.$element.off('click').on('click', (e) => {
            if (!$(e.target).closest('.modal__container').length) {
                self.changeHref();
            }
        });

        $(window.document).off('keyup').on('keyup', (e) => {
            if (e.keyCode === 27) {
                self.changeHref();
            }
        });

        $(window).off('hashchange').on('hashchange', this.modalFixBody.bind(self));

        $('[data-close-modal]').off('click.modal').on('click.modal', () => {
            self.changeHref();
        });

        this.modalFixBody();
    };

    changeHref() {
        this.modalClose();
        if (this.noHistory) {
            location.replace(location.href.split('#')[0] + this.closedModalHash);
        } else {
            location.href = this.closedModalHash;
        }
    };

    modalOpen() {
        $('body').addClass('modal-open');
    };

    modalClose() {
        $('body').removeClass('modal-open');
    };

    escapeSelector(value) {
        if (typeof value === 'undefined' || !value) {
            return '';
        }

        return '#' + value.replace(/[!'#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '');
    };

    modalFixBody() {
        let self = this;

        if (location.hash !== this.closedModalHash && $(this.escapeSelector(location.hash)).hasClass('modal')){
            self.modalOpen();
            self.showIframe();
            return;
        }

        self.modalClose();
    };

    showIframe() {
        this.$element.find('[data-src]').each(function(i, el) {
            if (typeof window.componentNamespace.LazyIframe !== 'undefined') {
                new window.componentNamespace.LazyIframe(el);
            }
        });
    };

    getUrlVars()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
}
